import {ColorMatrixFilter,type Sprite} from 'pixi.js';
import manifest from './npc-variants.json';
import {MAIN_WORLD} from './world';
export interface NpcVariant {baseId:number;tier:number;hue:number;shiny:boolean}
export function npcVariant(id:number):NpcVariant|undefined{
 const rows=manifest[MAIN_WORLD?'monument':'legacy'] as Record<string,NpcVariant>;
 return rows[String(id)];
}
const filters=new WeakMap<Sprite,{id:number;filter:ColorMatrixFilter}>();
/** Per-sprite filters preserve the original texture, transparency and all frames. */
export function applyNpcVariant(sprite:Sprite,id:number,time:number):NpcVariant|undefined{
 const variant=npcVariant(id);
 if(!variant||!variant.hue&&!variant.shiny){if(filters.has(sprite)){sprite.filters=null;filters.delete(sprite);}return variant;}
 let entry=filters.get(sprite);
 if(!entry||entry.id!==id){const filter=new ColorMatrixFilter();entry={id,filter};filters.set(sprite,entry);sprite.filters=[filter];}
 entry.filter.reset();if(variant.hue)entry.filter.hue(variant.hue,true);
 if(variant.shiny){entry.filter.saturate(.12,true);entry.filter.brightness(1.025+.045*(Math.sin(time/750+id)+1),true);}
 return variant;
}
